module.exports = __webpack_public_path__ + "static/img/iron-ore_256.34846d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iron-ore_256.png
// module id = RhwD
// module chunks = 0